import { render, staticRenderFns } from "./FeatureBody.vue?vue&type=template&id=756a6272&scoped=true&"
import script from "./FeatureBody.vue?vue&type=script&lang=ts&"
export * from "./FeatureBody.vue?vue&type=script&lang=ts&"
import style0 from "./FeatureBody.vue?vue&type=style&index=0&id=756a6272&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756a6272",
  null
  
)

export default component.exports